<template>
  <div>
    
    <vs-divider class="m-1"> Responsáveis </vs-divider>

    <validation-observer ref="form">

      <b-form @submit.prevent="save">

        <div class="vx-row">
          
            <div class="vx-col w-full mb-2">
              <label>Responsável:</label>

              <!-- button on both side -->
              <b-input-group>
                <b-form-input v-model="sponsorName" readonly/>
                <b-input-group-append>
                  <b-button variant="outline-primary" @click="showSponsorSearchGrid = true">
                    <feather-icon
                      icon="SearchIcon"
                      class="mr-50"
                    />
                    <span class="align-middle">Buscar</span>
                  </b-button>
                  <b-button variant="outline-primary" @click="showNaturalEntityCreateForm = true">
                    <feather-icon
                      icon="PlusIcon"
                      class="mr-50"
                    />
                    <span class="align-middle">Incluir</span>
                  </b-button>
                  <b-button variant="outline-primary" @click="sponsor = null">
                    <feather-icon
                      icon="XIcon"
                      class="mr-50"
                    />
                    <span class="align-middle">Limpar</span>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
         
        </div>

        <div class="vx-row">
          <div class="vx-col w-full float-right">

            <b-form-group
              label="Ponto focal"
              label-for="focal_point"
              class="float-right"
            >
              <validation-provider
                #default="{ errors }"
                name="focal_point"
              >
                <b-form-checkbox
                  v-model="focalPoint"
                  class="mr-0 mt-50"
                  name="focal_point"
                  switch
                  inline
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            
            <b-button
              v-if="editMode"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              @click="cancelEdit"
              class="mt-2 float-right"
            >
              Cancelar
            </b-button>

            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
              :class="['float-right', {'mr-2': editMode}]"
              :disabled="!validateSponsor"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-50"
              />
              <span class="align-middle">Adicionar responsável</span>
            </b-button>

          </div>
        </div>
        
      </b-form>
    </validation-observer>
    

    <div class="vx-row mt-4 mb-10">
      <div class="vx-col w-full">
        <vs-table :data="organizationalUnit.sponsors" no-data-text="Nenhum registro encontrado">
          <template slot="thead">
            <vs-th>Nome</vs-th>
            <vs-th>Sobrenome</vs-th>
            <vs-th>Ponto Focal</vs-th>
            <vs-th>Ações</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{data[indextr].sponsor.first_name}}</vs-td>
              <vs-td>{{data[indextr].sponsor.surname}}</vs-td>
              <vs-td>
                <span v-if="data[indextr].focal_point">Sim</span>
                <span v-else>Não</span>
              </vs-td>
              <vs-td>
                <feather-icon
                  icon="Trash2Icon"
                  title="Excluir"
                  style="cursor: pointer;"
                  class="h-5 w-5 mb-1 mr-3 stroke-current text-danger"
                  @click="destroy(data[indextr])"
                />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>

    <vs-popup fullscreen title="Cadastrar Responsável" :active.sync="showNaturalEntityCreateForm">
      <NaturalEntityForm :services="services" :naturalEntityId="null" hide_spouse="true" />
    </vs-popup>

    <vs-popup title="Pessoa Natural" :active.sync="showSponsorSearchGrid">
      <Grid
        :service="naturalEntityService"
        route_name="natural_entities"
        hide_actions="true"
        :delegate="{itemSelected: () => sponsorSelected}"
      ></Grid>
    </vs-popup>

  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { 
  BForm, 
  BButton, 
  BFormInput, 
  BFormGroup, 
  BFormRadioGroup, 
  BFormCheckbox,
  BInputGroup, 
  BInputGroupAppend 
} from 'bootstrap-vue'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'

import Datepicker from 'educatena-vuejs-datepicker'
import vSelect from 'vue-select'
import NaturalEntityForm from './NaturalEntityForm.vue'
import NaturalEntityService from '@/services/api/NaturalEntityService'

export default {
  directives: {
    Ripple,
  },
  components: {
    NaturalEntityForm,
    Datepicker,
    vSelect,
    // BSV
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
    BFormCheckbox,
    BFormCheckbox,
    BInputGroup, 
    BInputGroupAppend,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    people_id: {
      type: Number,
      default: null
    },
    services: {
      type: Object,
      default: null
    },
    organizationalUnit: {
      type: Object,
      default: null
    },
  },
  data: () => ({
    showNaturalEntityCreateForm: false,
    showSponsorSearchGrid: false,
    naturalEntityService: null,
    parentEntity: null,
    sponsor: null,
    focalPoint: false,
    level: null,
    levels: [
      { text: 'Estratégico', value: 'strategic' },
      { text: 'Tático', value: 'tatital' },
      { text: 'Operacional', value: 'operational' },
    ],
    editMode: false,
    // validation rules
    required,
  }),
  computed: {
    sponsorName() {
      return this.sponsor ? `${this.sponsor.first_name} ${this.sponsor.surname}`  : ''
    },
    levelState() {
      return Boolean(this.level)
    },
    validateSponsor() {
      return this.sponsor !== null
    }
  },
  watch: {},
  methods: {
    save() {

      this.$refs.form.validate().then(success => {
        if (success) {

          this.clearErrors(this.$refs.form)
          this.$vs.loading()

          const params = {
            organizational_unit_id: this.organizationalUnit.id,
            sponsor_id: this.sponsor.id,
            focal_point: this.focalPoint
          }

          this.services.organizationalUnitSponsorService.create(params).then(
            data => {
              this.$vs.loading.close()
              
              this.organizationalUnit.sponsors.push(data)
              this.editMode = false
              this.clearFields()
              this.notifySuccess(this.$vs)
            },
            error => {
              this.$vs.loading.close()
              this.showErrors(this.$refs.form, error)
            }
          )
        }
      })
      
    },
    destroy(sponsor) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja excluir este registro?',
        accept: () => {
          this.acceptDestroy(sponsor)
        }
      })
    },
    acceptDestroy(sponsor) {
      this.$vs.loading()
      this.services.organizationalUnitSponsorService
        .destroy({
          id: sponsor.id
        })
        .then(
          data => {
            this.$vs.loading.close()
            this.organizationalUnit.sponsors = this.organizationalUnit.sponsors.filter(element => {
              return element.id !== sponsor.id
            })
            this.notifySuccess(this.$vs)
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$validator, error)
          }
        )
    },
    clearFields() {
      this.sponsor = null
      this.focalPoint = false
    },
    sponsorSelected(naturalEntity) {
      this.sponsor = naturalEntity
      this.showSponsorSearchGrid = false
    },
  },
  beforeMount() {
    this.naturalEntityService = NaturalEntityService.build(this.$vs)
  },
  mounted() {

    this.$root.$on('naturalEntityCreated', naturalEntity => {
      if (this.showNaturalEntityCreateForm) {
        this.sponsor = naturalEntity
        this.showNaturalEntityCreateForm = false
      }
    })

  }
}
</script>